import { Lock, RotateCcw, Shuffle } from '@insify/design-system/icons';
import { Checkout } from '@insify/funnel-components';
import { useTranslation } from 'react-i18next';

import { useConditionsQuery } from '../../../../hooks/useQueries';

export const USPs = ({ className }: { className?: string }) => {
  const { t } = useTranslation(['funnel']);
  const { dailyCancellable = true } = useConditionsQuery()?.data?.professionalLiability ?? {};

  const usps = [
    ...(dailyCancellable ? [{ icon: <RotateCcw />, text: t('funnel:checkout_submit_no_commitment') }] : []),
    {
      icon: <Shuffle />,
      text: t('funnel:checkout_submit_flexibility'),
    },
    {
      icon: <Lock />,
      text: t('funnel:checkout_submit_ssl'),
      highlighted: true,
    },
  ];

  return <Checkout.USPs className={className} usps={usps} />;
};
